import * as React from 'react'

import { PerformanceFeatureAvailability } from 'modules/performance/lib/featuresAvailability'

export interface ContextProps {
  performanceFeatureAvailability: PerformanceFeatureAvailability
  hasFullVisibility: boolean
}

export const PerformanceModuleContext = React.createContext<ContextProps | null>(null)
